import { useCallback } from 'react';
import { useDispatch } from 'core/common/hooks';
import { ContentOffer, OffersByCategory } from '../entities';
import { fetchOffersByCategory } from '../store';

type UseFetchOffersParams = {
  offers: OffersByCategory;
  contentOffer?: ContentOffer;
};

export function useFetchOffers({ offers, contentOffer }: UseFetchOffersParams) {
  const dispatch = useDispatch();

  const doFetchOffers = useCallback(() => {
    dispatch(fetchOffersByCategory(offers, contentOffer));
  }, [dispatch, offers, contentOffer]);

  return {
    fetchOffers: doFetchOffers,
  };
}
